import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import USCommercialSubNav from './USCommercialSubNav';
import { Icon, Size, Color } from '@americanexpress/aqx-components';
import {
  getPageGlobalData,
  getActivePageName,
  getPageCardsData,
  getExperimentalPageData
} from 'src/universal/redux/page';
import { mapUrlWithDtmLinkQuery } from 'service_modules/models/dtm-tagging';
import styles from './__styles__/index.scss?modules';
import { getPageTypeVal } from './utils';
import isProduction from 'src/universal/utils/isProduction';
import { isG170MobileB } from '../Experiments/G170/redux';
import MobileVariantB from '../Experiments/G170/Components/MobileVariantB';
import TrackExperimentImpression from 'src/universal/components/TrackExperimentImpression';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';

const VacAnchor = ({ data }) => (
  <a
    href={mapUrlWithDtmLinkQuery(data.href, data.dtm)}
    className={styles.anchorHeader}
  >
    <Icon
      directory="dls"
      imageName="dls-icon-left"
      $size={Size.SM}
      theme={{
        color: Color.BrightBlue
      }}
    />
    <p>{data.content}</p>
  </a>
);

const VacAnchorB = ({
  data,
  g170Data,
  cardArt,
  open,
  toggleOpen,
  modalOpen,
  toggleModalOpen
}) => {
  const parsedDtmEvents = parseArrayToObject(g170Data?.dtmEvents || [], 'key');
  const clickHandler = () => {
    if (modalOpen) {
      toggleModalOpen(false);
    }
    const dtm = open
      ? parsedDtmEvents?.dropdownUpScrollClick
      : parsedDtmEvents?.dropdownDownScrollClick;

    sendDTMClickEvent(dtm);
    toggleOpen(prev => !prev);
  };
  return (
    <React.Fragment>
      <a
        href={mapUrlWithDtmLinkQuery(data.href, data.dtm)}
        className={styles.anchorHeader}
      >
        <Icon
          directory="dls"
          imageName="dls-icon-left"
          $size={Size.SM}
          theme={{
            color: Color.BrightBlue
          }}
        />
        <p>{data.content}</p>
      </a>
      <button
        className={styles.variantBButton}
        onClick={clickHandler}
        aria-label="More card options"
        aria-expanded={open}
        aria-haspopup="dialog"
      >
        <img src={cardArt} className={styles.variantBCardart} alt="" />
        <Icon
          directory="dls"
          imageName={`dls-icon-${open ? 'up' : 'down'}-filled`}
          $size={Size.SM}
          theme={{
            color: Color.BrightBlue
          }}
        />
      </button>
    </React.Fragment>
  );
};

const Logo = ({ data }) => {
  const amexHost = isProduction()
    ? 'https://icm.aexp-static.com/'
    : 'https://qicm.aexp-static.com/';

  const imageUrl = data.imageUrl.startsWith('https')
    ? data.imageUrl
    : `${amexHost}${data.imageUrl}`;

  return (
    <a href={mapUrlWithDtmLinkQuery(data.href, data.dtm)}>
      <img src={imageUrl} alt={data.imageAlt} className={styles.logoImg} />
    </a>
  );
};

const MobileSubnav = ({
  activePageName,
  data,
  pageGlobalData,
  segmentParams,
  G170MobileB,
  pageCardsData,
  xpData
}) => {
  const [variantBOpen, toggleVariantBOpen] = useState(false);
  const [modalOpen, toggleModalOpen] = useState(false);

  const menuRef = useRef(null);

  useEffect(() => {
    const handler = e => {
      if (
        typeof menuRef.current?.contains === 'function' &&
        !menuRef.current.contains(e.target)
      ) {
        toggleVariantBOpen(false);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchmove', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchmove', handler);
    };
  }, []);

  const globalData = pageGlobalData.applyByPhoneNumber ? pageGlobalData : data;
  if (typeof window === 'undefined' || !globalData) {
    return null;
  }

  const pageName = getPageTypeVal(activePageName, segmentParams);

  const vacAnchorData =
    globalData?.globalHeaderPage?.commercialSubNav?.vacAnchor || {};
  const logoData = globalData?.globalHeaderPage?.commercialSubNav?.logo || {};
  const headerType =
    globalData?.globalHeaderPage?.commercialSubNav?.headerType?.[pageName] || '';
  const phoneNumber =
    globalData?.globalHeaderPage?.commercialSubNav?.numberObject?.[pageName] || '';

  const cardArtVariant = pageCardsData?.[0]?.appAssets?.cardArt;

  if (G170MobileB) {
    return (
      <div ref={menuRef}>
        <TrackExperimentImpression experimentName="GCS-170-PDP-Filmstrip-Mobile" />
        <USCommercialSubNav
          header={
            <VacAnchorB
              data={vacAnchorData}
              g170Data={xpData?.g170SubnavData}
              cardArt={cardArtVariant}
              open={variantBOpen}
              toggleOpen={toggleVariantBOpen}
              modalOpen={modalOpen}
              toggleModalOpen={toggleModalOpen}
            />
          }
          phoneNumber={phoneNumber}
          createLinkNav={mapUrlWithDtmLinkQuery}
          showCta={phoneNumber && true}
          open={modalOpen}
          toggleOpen={toggleModalOpen}
          variantOpen={variantBOpen}
          toggleVariantOpen={toggleVariantBOpen}
        />
        <MobileVariantB
          open={variantBOpen}
          data={xpData?.g170SubnavData}
          shortName={pageCardsData?.[0]?.shortName}
        />
      </div>
    );
  }

  return (
    <USCommercialSubNav
      header={
        headerType === 'vacAnchor' ? (
          <VacAnchor data={vacAnchorData} />
        ) : (
          <Logo data={logoData} />
        )
      }
      phoneNumber={phoneNumber}
      createLinkNav={mapUrlWithDtmLinkQuery}
      showCta={phoneNumber && true}
      open={modalOpen}
      toggleOpen={toggleModalOpen}
      variantOpen={variantBOpen}
      toggleVariantOpen={toggleVariantBOpen}
    />
  );
};

const mapStateToProps = state => {
  return {
    activePageName: getActivePageName(state),
    pageGlobalData: getPageGlobalData(state),
    G170MobileB: isG170MobileB(state),
    pageCardsData: getPageCardsData(state),
    xpData: getExperimentalPageData(state)
  };
};

export default connect(mapStateToProps)(MobileSubnav);
